export default {"src":"/_next/static/image/public/images/flags/flag_265.5dd710749084f13596c33949fcd0e671.svg","height":16,"width":24};